import { path } from 'src/constants/path'

export const handleGoToELearningList = () => {
  window.location.href = path.eLearning
}

export const handleGoToMyClass = () => {
  window.location.href = path.myClass
}